import { Box, IconButton, Typography } from "@mui/material";

import { DialogScreen } from "../schema";

interface Props {
  screen: DialogScreen;
  totalBrands: number;
  handleBack: () => void;
}

const MainDialogHeader = ({ screen, totalBrands, handleBack }: Props) => {
  if (screen === DialogScreen.success) return null;

  const title =
    screen === DialogScreen.review_brands
      ? `Review ${totalBrands} Brands`
      : `Schedule ${totalBrands} Emails`;

  return (
    <Typography variant="h6" sx={{ mb: 3 }} component="div">
      {screen !== DialogScreen.templates_and_time && (
        <IconButton onClick={handleBack} sx={{ ml: -1 }}>
          <Box
            component="i"
            className="fa-regular fa-arrow-left"
            sx={{ fontSize: 16 }}
          />
        </IconButton>
      )}
      {title}
    </Typography>
  );
};

export default MainDialogHeader;
